import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

export default task(async function(id, { firstName, lastName }) {
  const api = inject(ApiService)
  await api.request({
    url: `/api/accounts/${id}`,
    method: 'PATCH',
    data: { firstName, lastName }
  })
  return true
}, {
  defaultValue: false
})



// WEBPACK FOOTER //
// ./src/tasks/updateAccount.js